import { render } from "./BarcodeAttachedFile.vue?vue&type=template&id=8d5a5742"
import script from "./BarcodeAttachedFile.vue?vue&type=script&lang=ts"
export * from "./BarcodeAttachedFile.vue?vue&type=script&lang=ts"
script.render = render

export default script